import { NgModule } from '@angular/core';

import { ExchangeComponent } from "./exchange.component";
import { CommonModule } from "@angular/common";
import { PriceModule } from "libraries/component/price/price.module";

@NgModule({
    imports: [
        CommonModule,
        PriceModule,
    ],
    exports: [ExchangeComponent],
    declarations: [ExchangeComponent],
    providers: [],
})
export class ExchangeModule {
}
